module.exports = __webpack_public_path__ + "images/marketing/peeps/martine_quinn.jpg";